import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ContentContainer } from '../../../../core/content-container/content-container';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-mentorship-banner',
  imports: [ContentContainer, RouterLink],
  templateUrl: './mentorship-banner.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MentorshipBanner {}
